import { useEffect, useRef } from "react";

/** Disambiguate single vs. double click on the same element. `onSingle` is deferred by
 *  `delay` ms so a second click within the window cancels it and fires `onDouble` instead.
 *  Cleans up the pending timer on unmount. */
export function useSingleDoubleClick(onSingle: () => void, onDouble: () => void, delay = 250) {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  return {
    onClick: () => {
      clearTimeout(timer.current);
      timer.current = setTimeout(onSingle, delay);
    },
    onDoubleClick: () => {
      clearTimeout(timer.current);
      onDouble();
    },
  };
}
